var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox"},[_c('input',{staticClass:"checkbox-input",attrs:{"type":"checkbox","name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.emmitClick}}),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }